




























































import Vue from 'vue'

declare global {
  interface Window { PayPal: any }
}
window.PayPal = window.PayPal || {}

export default Vue.extend({
  methods: {
    setEmailLink(): void {
      const linkContainer = document.getElementById('linkContainer')

      if (linkContainer) {
        linkContainer.setAttribute('href', `mailto:info.resourcesofxlifex@gmail.com`)
        linkContainer.innerHTML += 'info.resourcesoflife@gmail.com'
      }
    },
  },
  mounted() {
    // hack to hide font loading
    setTimeout(() => {
      this.setEmailLink()

      if (window.PayPal) {
        window.PayPal.Donation.Button({
          env: 'production',
          hosted_button_id: 'HXKYQF3ALWKZ2',
          image: {
            alt: 'Donate with PayPal button',
            src: 'https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif',
            title: 'PayPal - The safer, easier way to pay online!',
          },
        }).render('#donate-button')
      }
    }, 1000)
  },
  name: 'about',
})
